var BASE = "/api/pantry";
var headers = { "Content-Type": "application/json" };
var opts = { credentials: "include", headers: headers };

async function handleResponse(res, fallbackMsg) {
  if (res.ok) return res.json();
  var body;
  try {
    body = await res.json();
  } catch (e) {
    body = null;
  }
  var msg = (body && (body.error || body.message)) || fallbackMsg;
  if (res.status === 401) msg = "Session expired — please log in again";
  throw new Error(msg);
}

/** Best-effort grocery category from a pantry line label. */
export function guessGroceryCategory(name) {
  var n = String(name).toLowerCase();
  if (/egg|milk|butter|cheese|yogurt|cream|creamer|half\s*&\s*half/.test(n)) return "dairy";
  if (/chicken|beef|pork|fish|salmon|turkey|tofu|sausage|bacon|meat|shrimp/.test(n)) return "protein";
  if (/apple|banana|onion|tomato|lettuce|potato|carrot|pepper|berry|fruit|vegetable|garlic|lime|lemon|avocado|spinach|herb|greens|celery|broccoli/.test(n)) return "produce";
  if (/rice|pasta|oat|flour|bread|cereal|grain|tortilla|noodle|quinoa/.test(n)) return "grain";
  if (/oil|spice|salt|vinegar|stock|honey|sugar|sauce|syrup|mayo|mustard|ketchup|flour|baking|nut|peanut|coffee|tea/.test(n)) return "pantry";
  if (/frozen|ice\s*cream|popsicle/.test(n)) return "frozen";
  return "other";
}

export async function fetchSnapshots() {
  var res = await fetch(BASE + "/snapshots", { credentials: "include" });
  return handleResponse(res, "Failed to load pantry snapshots");
}

export async function createSnapshot(payload) {
  var res = await fetch(BASE + "/snapshots", Object.assign({}, opts, { method: "POST", body: JSON.stringify(payload || {}) }));
  return handleResponse(res, "Failed to save snapshot");
}

export async function updateSnapshot(id, payload) {
  var res = await fetch(BASE + "/snapshots/" + encodeURIComponent(id), Object.assign({}, opts, { method: "PUT", body: JSON.stringify(payload || {}) }));
  return handleResponse(res, "Failed to update snapshot");
}

export async function deleteSnapshot(id) {
  var res = await fetch(BASE + "/snapshots/" + encodeURIComponent(id), { method: "DELETE", credentials: "include" });
  return handleResponse(res, "Failed to delete snapshot");
}

export async function duplicateSnapshot(id) {
  var res = await fetch(BASE + "/snapshots/" + encodeURIComponent(id) + "/duplicate", Object.assign({}, opts, { method: "POST", body: JSON.stringify({}) }));
  return handleResponse(res, "Failed to duplicate snapshot");
}
